import React from 'react';
import PropTypes from 'prop-types';
import StarRating from 'react-star-rating-component';

export default function Rating({ name, isEditing, value }) {
    return (
        <div className="rating" itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
            <StarRating
                name={name}
                editing={isEditing}
                starColor="#ff6600"
                emptyStarColor="#9f9fa1"
                //renderStarIconHalf={(val) => <div style={{ overflow: 'hidden', width: `${ ((val - value) * -100)}%` }}>&#9733;</div>}
                renderStarIcon={() => <div>&#9733;</div>}
                starCount={5}
                value={value}
            />
            <meta itemProp="ratingValue" content={value} />
        </div>
    );
}

Rating.propTypes = {
    name: PropTypes.string.isRequired,
    reviews: PropTypes.number.isRequired,
    isEditing: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/rating/index.js